import React from 'react'
import ButtonCta from './atoms/ButtonCta'
import CompTitle from './atoms/CompTitle'
import { createUseStyles } from 'react-jss'
import ButtonLink from './atoms/ButtonLink'
import Carousel from 'react-multi-carousel'
import SVG from '../ui/SVG/SVG'
import { theme } from '../ui/theme'
import { isClientSide } from '../ui/Common/utils'
import obj2Arr from '../../utils/obj2Arr'
import Gtm from '../../utils/gtm'
import { loggingEnabled } from '../../utils/logging'

const ThreeGrid = props => {
  const useStyles = createUseStyles(theme => ({
    carouselCustomArrowsLeft: {
      textAlign: 'center',
      paddingRight: 9,
      borderRadius: '50%',
      backgroundColor: theme.colors.blue,
      height: 30,
      width: 30,
      zIndex: 1,
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'all',
      boxShadow: 'none',
      border: 'none',
      textShadow: 'none',
      margin: '-2em',
      top: 'calc(50% - 23px)',
      left: 0,

      '@media (min-width: 1200px)': {
        display: 'none !important',
      },

      '@media (max-width: 1200px)': {
        left: 25,
      },

      '@media (max-width: 600px)': {
        // display: 'none',
        top: 'calc(50% - 90px)',
        left: 0,
        padding: 0,
        margin: 0,
      },

      '& svg': {
        transform: 'rotate(180deg) scale(0.75)',
        transformOrigin: 'center',
      },
    },
    carouselCustomArrowsRight: {
      paddingLeft: 9,
      textAlign: 'center',
      borderRadius: '50%',
      backgroundColor: theme.colors.blue,
      height: 30,
      width: 30,
      zIndex: 1,
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'all',
      boxShadow: 'none',
      border: 'none',
      textShadow: 'none',
      margin: '-2em',
      top: 'calc(50% - 23px)',
      right: 0,

      '@media (min-width: 1200px)': {
        display: 'none !important',
      },

      '@media (max-width: 1200px)': {
        right: 25,
      },
      '@media (max-width: 600px)': {
        right: 40,
        top: 'calc(50% - 90px)',
        padding: 0,
        margin: 0,
      },
      '& svg': {
        transform: 'scale(0.75)',
        transformOrigin: 'center',
      },
    },
    popularSection: {
      fontFamily: theme.fontFamily,
      paddingBottom: 75,
      paddingTop: 85,

      '@media (max-width: 600px)': {
        paddingBottom: 40,
        paddingTop: 35,
      },
      '& .react-multi-carousel-list': {
        paddingBottom: 50,
      },
      '& .react-multi-carousel-dot button': {
        backgroundColor: theme.colors.cloudyBlue,
        border: 'none',
        width: 7,
        height: 7,
      },
      '& .react-multi-carousel-dot--active button': {
        backgroundColor: theme.colors.blue,
      },
      '& img': {
        // width: '100%'
      },
    },
    popularCarouselWrapper: {
      position: 'relative',
    },
    carouselCustomArrows: {
      top: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    },
    popularCarousel: {
      margin: '50px 0 25px 0',
      '@media (max-width: 900px)': {
        margin: '35px 0 15px',
      },

      '& .carousel .slide': {
        backgroundColor: 'transparent',
        textAlign: 'left',
      },
      '& .carousel.carousel-slider': {
        overflow: 'visible',
      },
      '& .carousel .control-dots': {
        bottom: '-38px',
        paddingLeft: 0,
      },
      '& .carousel .control-dots .dot': {
        backgroundColor: '#bbcad8',
        boxShadow: 'none',
        opacity: 0.7,
        transition: `background-color 250ms ${theme.animations.bezier}, opacity 250ms ${theme.animations.bezier}`,
      },
      '& .carousel .control-dots .dot.selected': {
        backgroundColor: theme.colors.blue,
        opacity: 1,
      },
      '& .carousel .control-dots .dot:hover': {
        backgroundColor: theme.colors.blue,
        opacity: 1,
      },
    },
    container: {
      padding: '45px 0',
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
      '@media (max-width: 1200px)': {
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
      '@media (max-width: 700px)': {
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
    },
    wrapper: {
      // display: 'grid',
      // justifyContent: 'space-evenly',
      // gridTemplateColumns: '1fr 1fr 1fr',
      // gridGap: '20px',
      // '@media (max-width: 600px)': {
      //   gridTemplateColumns: '1fr !important',
      //   width: 285,
      //   margin: '0 auto',
      // },
    },
    img: {
      objectFit: 'cover',
      maxWidth: '100%',
      height: 'auto',
      verticalAlign: 'bottom',
    },
    imgBlog: {
      objectFit: 'cover',
      maxWidth: '100%',
      height: 'auto',
      verticalAlign: 'bottom',
      height: '200px',
    },
    title: {
      fontSize: '26px',
      lineHeight: '28px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      paddingTop: '4px',
      paddingBottom: '10px',
      color: '#007AC3',
      overflow: 'hidden',
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
    details: {
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      fontFamily: 'AvenirNextLTPro',
      textAlign: 'left',
      color: '#2D2D2D',
      '& a': {
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineClamp: 2,
        color: 'inherit',
        textDecoration: 'none',
      },
    },
    buttonCont: {
      textAlign: 'center',
      paddingTop: '30px',
      '@media (max-width: 600px)': {
        paddingTop: '15px',
      },
    },
    contenti: {
      padding: '17px 30px',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      '@media (max-width: 600px)': {
        padding: '10px 15px',
        flexGrow: 0,
      },
    },
    innerCTA: {
      textAlign: 'left',
      marginTop: '20px',
      alignItems: 'flex-end',
      '@media (max-width: 600px)': {
        marginTop: '10px',
      },
    },
    boxShadowStuff: {
      boxSizing: 'border-box',
      height: '100%',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '1px 5px 10px rgba(0, 0, 0, 0.15)',
      '&:hover': {
        boxShadow: '1px 5px 10px rgba(0, 0, 0, 0.35)',
      },
    },
  }))

  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)

  const { title_align, title, linkText, linkURL, grids, blogpost, posts } = props

  let griditems = grids
  if (blogpost) {
    griditems = posts
  }

  const objArr = obj2Arr(griditems)

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: objArr.length,
    },
    desktopSmall: {
      breakpoint: { max: 1200, min: 1024 },
      items: objArr.length,
    },
    tabletLandscape: {
      breakpoint: { max: 1024, min: 770 },
      items: objArr.length,
    },
    tabletPortait: {
      breakpoint: { max: 769, min: 600 },
      items: 2,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      partialVisibilityGutter: 40,
    },
  }

  const ButtonGroup = ({ next, previous, ...rest }) => {
    return (
      <div className={classes.carouselCustomArrows}>
        <button className={classes.carouselCustomArrowsLeft} onClick={() => previous()}>
          <SVG name={'Chevron'} width={14} height={30} colorOne={theme.colors.white} />
        </button>
        <button className={classes.carouselCustomArrowsRight} onClick={() => next()}>
          <SVG name={'Chevron'} width={14} height={30} colorOne={theme.colors.white} />
        </button>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <CompTitle text={title} align={title_align} />

      <div className={classes.wrapper}>
        <div style={{ position: 'relative' }}>
          <Carousel
            className={classes.popularCarousel}
            deviceType={isClientSide() ? null : 'desktop'}
            infinite={objArr.length > 1}
            arrows={false}
            showDots={false}
            responsive={responsive}
            ssr={true}
            partialVisible={objArr.length > 1}
            autoPlay={false}
            autoPlaySpeed={4000}
            renderButtonGroupOutside={true}
            customButtonGroup={objArr.length > 1 ? <ButtonGroup /> : undefined}
          >
            {objArr &&
              objArr.map(section => {
                if (blogpost) {
                  section = section.post
                  section.details = section.BlogPage.summary || ''
                  section.img = section.BlogPage.img
                  section.buttonText = 'read more'
                }

                return (
                  <div
                    key={section.title}
                    style={{
                      padding: 15,
                      boxSizing: 'border-box',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,
                    }}
                  >
                    <div className={classes.boxShadowStuff}>
                      <div
                        style={{
                          backgroundImage: 'linear-gradient(to bottom, #e1e1e1 , #fff)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <a
                          onClick={() => {
                            gtm.contentTilesClick(title, section.title)
                          }}
                          href={section.url}
                        >
                          <img
                            src={section.img}
                            alt={section.alt}
                            className={blogpost ? classes.imgBlog : classes.img}
                          />
                        </a>
                      </div>

                      <div className={classes.contenti}>
                        <div>
                          <div className={classes.title}>
                            <a
                              onClick={() => {
                                gtm.contentTilesClick(title, section.title)
                              }}
                              href={section.url}
                            >
                              {section.title}
                            </a>
                          </div>
                          {section.details && section.details !== '' && (
                            <div className={classes.details}>
                              <a
                                onClick={() => {
                                  gtm.contentTilesClick(title, section.title)
                                }}
                                href={section.url}
                              >
                                {section.details}
                              </a>
                            </div>
                          )}
                        </div>
                        {section.buttonText !== '' && (
                          <div className={classes.innerCTA}>
                            <ButtonLink
                              primary={blogpost}
                              text={section.buttonText}
                              url={section.url}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              })}
          </Carousel>
        </div>
      </div>

      {linkText && linkText !== '' && (
        <div className={classes.buttonCont}>
          <ButtonCta text={linkText} url={linkURL} />
        </div>
      )}
    </div>
  )
}

export default ThreeGrid
